import { treeAspectMinorTabgroup, wikiTab, isRootDomainConfig, isDomainRecord } from './utils';
export const sys = {
    ...treeAspectMinorTabgroup,
    tabGroup: 'sys',
    acl: 'g:admin',
    enabled: isDomainRecord,
    tabs: {
        overview: {
            default: true,
            tabGroupDefault: true,
            parts: [
                {
                    type: 'SysOverview',
                    filters: [
                        'getDashSysinfo',
                        'getDashStorage',
                        'getDashDomainInfo'
                    ]
                }
            ]
        },
        cfg: {
            parts: [
                {
                    type: 'InstanceCfgEditor',
                    filters: [
                        'getInstanceConfigs'
                    ]
                }
            ],
            acl: 'g:debug'
        },
        logs: {
            parts: [
                {
                    type: 'SysLogs',
                    filters: [
                        'getLoggingInfo'
                    ]
                }
            ]
        },
        cache: {
            minorTabGroup: 'caches',
            parts: [
                {
                    type: 'SysTool',
                    name: 'CacheInfo'
                }
            ],
            acl: 'g:debug'
        },
        apicache: {
            minorTabGroup: 'caches',
            parts: [
                {
                    type: 'SysTool',
                    name: 'ApiCacheInfo'
                }
            ],
            label: 'Api',
            acl: 'g:debug'
        },
        interpreter: {
            parts: [
                {
                    type: 'SimpleInterpreter',
                    style: {
                        overflow: 'hidden'
                    }
                }
            ],
            acl: 'g:debug'
        },
        sessions: {
            parts: [
                'SessionsViewer'
            ]
        },
        status: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'StartstopInfo',
                    filters: [
                        'getStartStopInfo'
                    ]
                }
            ],
            acl: 'g:debug'
        },
        startup: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'StartupAnalyzer',
                    filters: [
                        'getStartupInfo'
                    ]
                }
            ],
            acl: 'g:debug'
        },
        nginx: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'NginxInfo'
                }
            ],
            acl: 'g:debug'
        },
        source: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SourceStats',
                    filters: [
                        'getSourceStats'
                    ]
                }
            ],
            acl: 'g:debug'
        },
        views: {
            minorTabGroup: 'system',
            parts: [
                'InspectViews'
            ],
            acl: 'g:debug'
        },
        bundle: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'WebpackBundle',
                    style: {
                        display: 'flex',
                        overflow: 'hidden'
                    }
                }
            ],
            acl: 'g:debug'
        },
        nodes: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'ProcessNodes'
                }
            ],
            acl: 'g:debug'
        },
        poolexhaustions: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'PoolExhaustions'
                }
            ],
            acl: 'g:debug'
        },
        imgprofiles: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'ImageProfiles'
                }
            ],
            acl: 'g:debug'
        },
        threads: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SysThreads'
                }
            ],
            acl: 'g:debug'
        },
        fds: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SysFds'
                }
            ],
            acl: 'g:debug'
        },
        requests: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SysRequests'
                }
            ],
            acl: 'g:debug'
        },
        spabuild: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SpaBundleInfo'
                }
            ],
            acl: 'g:debug'
        },
        events: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'ServerEvents'
                }
            ],
            acl: 'g:debug'
        },
        pmove: {
            minorTabGroup: 'system',
            parts: [
                {
                    type: 'SysTool',
                    name: 'SysParentMove'
                }
            ],
            acl: 'g:debug'
        }
    }
};
